import { useQuery } from '@tanstack/react-query';
import { Api } from '@/core/api';
import { useCurrentUser } from '@/core/hooks/useCurrentUser';
import { AssetItem } from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';

export const QUERY_KEY_ASSET_DECISIONS = 'map-asset-decisions';

export const useAssetDecisions = ({ assetId }: { assetId: AssetItem['AssetID'] }) => {
  const { orgId } = useCurrentUser();
  const { data, ...query } = useQuery({
    queryKey: [QUERY_KEY_ASSET_DECISIONS, orgId, assetId],
    queryFn: () => Api.mapEvents.getAssetDecisions({ orgId, assetId }),
    placeholderData: [],
  });

  return { data, assetDecisions: data, ...query };
};
